import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradient%20background%20with%20soft%20amber%20gold%20and%20cream%20waves%2C%20minimal%20geometric%20texture%2C%20elegant%20modern%20design%2C%20warm%20atmosphere%2C%20no%20blue%20or%20purple%20hues%2C%20high%20quality%20editorial&width=1600&height=600&seq=cta-bg-home&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-background-950/60 to-background-950/80"></div>

      <div className="relative z-10 container-custom text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
          加入黑料社区，探寻事件真相
        </h2>
        <p className="mt-3 text-sm md:text-base text-background-200/80 max-w-xl mx-auto leading-relaxed">
          成为社区的一员，浏览独家内容、参与讨论、分享你的见闻。真相，值得被更多人看到。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zuixin-baoliao"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-md text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即浏览内容
          </Link>
          <Link
            to="/category/wangyou-tougao"
            className="px-8 py-3 border border-background-50/30 text-background-50 rounded-md text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            我要爆料
          </Link>
        </div>
      </div>
    </section>
  );
}